/** @format */

import { ITreeNode, TreeNode } from '@designable/core'
import { transformToSchema, transformToTreeNode } from '@designable/formily-transformer'
import { MonacoInput } from '@designable/react-settings-form'
import React from 'react'
// setNpmCDNRegistry('https://static.bianque.ksyun.com/npm')

export interface ISchemaEditorWidgetProps {
  tree: TreeNode
  onChange?: (tree: ITreeNode) => void
}

export const SchemaEditorWidget: React.FC<ISchemaEditorWidgetProps> = props => {
  return (
    <MonacoInput
      {...props}
      value={JSON.stringify(transformToSchema(props.tree), null, 2)}
      onChange={value => {
        props.onChange?.(transformToTreeNode(JSON.parse(value)))
      }}
      language="json"
    />
  )
}
